import { TICKET_CALC_DATA_RECEIVED, PURCHASE_RESTRICTIONS } from '../config/const';
import * as modal from '../reducers/modalReducer';
import { setPurchaseLimitsExceeded } from '../reducers/summaryReducer';
import { toBool, getConfigValue } from '../reducers/configReducer';
import { getCurrentPurchaseLimits } from '../selectors/purchase_limits/purchase_limits_selectors';

const openPurchaseLimitsModal = (store) => {
  const state = store.getState();
  if (modal.isModalOpened(state) && modal.getModalName(state) !== 'PURCHASE_LIMITS_FORM') {
    setTimeout(() => openPurchaseLimitsModal(store), 1000);
    return;
  }
  store.dispatch(
    modal.openModal({
      modalType: 'PURCHASE_LIMITS_FORM',
      modalProps: {},
    }),
  );
};

const patientLimitsMiddleware = store => next => (action) => {
  if (action.type === TICKET_CALC_DATA_RECEIVED) {
    const state = store.getState();
    const limitsEnabled = toBool(getConfigValue(PURCHASE_RESTRICTIONS, state));
    if (limitsEnabled) {
      const usageLimitInfo = getCurrentPurchaseLimits(state);
      if (usageLimitInfo) {
        if (isLimitsNotExceeded(usageLimitInfo)) {
          store.dispatch(setPurchaseLimitsExceeded(false));
        } else {
          store.dispatch(setPurchaseLimitsExceeded(true));
          openPurchaseLimitsModal(store, state);
        }
      }
    }
  }
  next(action);
};

const isLimitsNotExceeded = (a) => {
  const passed = Object.keys(a).reduce((acc, val) => {
    acc += a[val].letPay === true;
    return acc;
  }, 0);
  const total = Object.keys(a).length;
  return total === passed;
};

export default patientLimitsMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/patientLimitsMiddleware.js